import React, { useState } from 'react';

const EMPLOYEES = [
  { id: 'E01', name: 'Alice Morgan', dept: 'Engineering', salary: 92000, level: 'Senior', status: 'Active' },
  { id: 'E02', name: 'Bob Chen', dept: 'Marketing', salary: 67000, level: 'Junior', status: 'Active' },
  { id: 'E03', name: 'Carol Davis', dept: 'Engineering', salary: 115000, level: 'Lead', status: 'Active' },
  { id: 'E04', name: 'Dave Kim', dept: 'HR', salary: 58000, level: 'Junior', status: 'Inactive' },
  { id: 'E05', name: 'Eve Wilson', dept: 'Finance', salary: 88000, level: 'Senior', status: 'Active' },
  { id: 'E06', name: 'Frank Lee', dept: 'Engineering', salary: 78000, level: 'Mid', status: 'Active' },
  { id: 'E07', name: 'Grace Park', dept: 'Marketing', salary: 72000, level: 'Mid', status: 'Active' },
  { id: 'E08', name: 'Henry Brown', dept: 'Finance', salary: 105000, level: 'Lead', status: 'Active' },
  { id: 'E09', name: 'Iris Patel', dept: 'HR', salary: 62000, level: 'Mid', status: 'Inactive' },
  { id: 'E10', name: 'Jack Turner', dept: 'Engineering', salary: 98000, level: 'Senior', status: 'Active' },
  { id: 'E11', name: 'Karen White', dept: 'Finance', salary: 71000, level: 'Junior', status: 'Active' },
  { id: 'E12', name: 'Leo Martinez', dept: 'Finance', salary: 94000, level: 'Senior', status: 'Active' },
];

const EXPECTED_ANSWER = 'Henry Brown';
const DEPTS = ['All', 'Engineering', 'Marketing', 'Finance', 'HR'];
const SORT_OPTIONS = ['None', 'Salary ↑', 'Salary ↓', 'Name A-Z'];

export default function C04_DataFind({ onComplete }) {
  const [deptFilter, setDeptFilter] = useState('All');
  const [sortBy, setSortBy] = useState('None');
  const [answer, setAnswer] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const filtered = EMPLOYEES
    .filter(e => deptFilter === 'All' || e.dept === deptFilter)
    .sort((a, b) => {
      if (sortBy === 'Salary ↑') return a.salary - b.salary;
      if (sortBy === 'Salary ↓') return b.salary - a.salary;
      if (sortBy === 'Name A-Z') return a.name.localeCompare(b.name);
      return 0;
    });

  const handleSubmit = () => {
    if (!answer.trim()) return;
    setSubmitted(true);
    const pass = answer.trim().toLowerCase() === EXPECTED_ANSWER.toLowerCase();
    onComplete({
      score: pass ? 100 : 0,
      details: { answer: { expected: EXPECTED_ANSWER, got: answer.trim(), pass } },
      passed: pass,
    });
  };

  return (
    <div className="ab-challenge-ui">
      <div className="ab-toolbar">
        <div className="ab-filter-group">
          <label>Department:</label>
          <select value={deptFilter} onChange={e => setDeptFilter(e.target.value)} className="ab-input ab-input-sm" disabled={submitted}>
            {DEPTS.map(d => <option key={d}>{d}</option>)}
          </select>
        </div>
        <div className="ab-filter-group">
          <label>Sort:</label>
          <select value={sortBy} onChange={e => setSortBy(e.target.value)} className="ab-input ab-input-sm" disabled={submitted}>
            {SORT_OPTIONS.map(s => <option key={s}>{s}</option>)}
          </select>
        </div>
        <span className="ab-row-count">{filtered.length} rows</span>
      </div>

      <div className="ab-table-wrap">
      <table className="ab-table">
        <thead>
          <tr><th>ID</th><th>Name</th><th>Department</th><th>Level</th><th>Salary ($)</th><th>Status</th></tr>
        </thead>
        <tbody>
          {filtered.map(e => (
            <tr key={e.id}>
              <td>{e.id}</td><td><strong>{e.name}</strong></td><td>{e.dept}</td>
              <td>{e.level}</td><td>{e.salary.toLocaleString()}</td>
              <td><span className={`ab-badge ${e.status === 'Active' ? 'ab-badge-green' : 'ab-badge-red'}`}>{e.status}</span></td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>

      <div className="ab-answer-row">
        <label className="ab-label">Your Answer (Full Name):</label>
        <input value={answer} onChange={e => setAnswer(e.target.value)} className="ab-input ab-answer-input"
          placeholder="Enter the employee's full name..." disabled={submitted} />
        {!submitted
          ? <button className="ab-action-btn" onClick={handleSubmit}>Submit Answer</button>
          : <div className="ab-submitted-badge">✓ Answer Submitted</div>
        }
      </div>
    </div>
  );
}
